import { render, staticRenderFns } from "./view-directSales.vue?vue&type=template&id=fa410324"
import script from "./view-directSales.vue?vue&type=script&lang=js"
export * from "./view-directSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports